import React from 'react';
import { Layout, Text } from 'elmo-elements';
import {
  CardWithBackground,
  SubHeading,
  ButtonWrapper,
  LoginLayout,
  LoginButton,
  LoginParagraph,
  Logo,
} from './style';
import logo from './assets/elmohub_logo.svg';
import { LoginProps } from './type';

function Login({ onLogin, error }: LoginProps) {
  return (
    <Layout>
      <LoginLayout>
        <CardWithBackground>
          <Logo src={logo} />
          <SubHeading>Welcome back</SubHeading>
          <LoginParagraph>Please sign in using your ELMO email</LoginParagraph>
          {error && <Text color="secondary">{error}</Text>}
          <ButtonWrapper>
            <LoginButton id="login-button" onClick={onLogin}>
              LOGIN WITH GOOGLE
            </LoginButton>
          </ButtonWrapper>
        </CardWithBackground>
      </LoginLayout>
    </Layout>
  );
}

export default Login;
